import type { WebLink as WebLinkType } from '../../../app-kit/components/WebLink/types';
import { useStatePageQuery } from '../../graphql/useStatePageQuery';
import { statePageQuery } from '../../graphql/statePageQuery';
import { ResultOf } from 'gql.tada';
import { StatePagePropertyCollectionBrick } from './StatePagePropertyCollectionBrick';
import { FunctionComponent } from 'react';
import { mapApiBadgeVariantToBadgeVariant } from '../../../app-kit/helpers/mapApiBadgeVariantToBadgeVariant';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';

type ApiStatePageWebLink = NonNullable<
  NonNullable<
    ResultOf<typeof statePageQuery>['statePageBySlug']
  >['propertyCollections'][number]['searchPageWebLink']
>;

const mapApiStatePageWebLinkToWebLink = (
  apiSearchPageWebLink: ApiStatePageWebLink,
): WebLinkType => {
  return {
    ...apiSearchPageWebLink,
    variant: mapApiWeblinkVariantToLinkVariant(apiSearchPageWebLink.variant),
  };
};

export const StatePagePropertyCollectionBricksWithData: FunctionComponent = () => {
  const statePage = useStatePageQuery()?.data?.statePageBySlug;

  const collections = statePage?.propertyCollections ?? [];
  if (!collections.length) return null;

  return (
    <>
      {collections.map(
        ({ title, subtitle, properties, tracking, searchPageWebLink, collectionType }) => {
          if (!properties) return null;
          return (
            <StatePagePropertyCollectionBrick
              title={title}
              subtitle={subtitle}
              key={title}
              showPropTrackLogo={collectionType === 'SOLD'}
              properties={properties.map(
                ({ path, clickThroughTracking, price, address, image, badge, features }) => ({
                  path,
                  clickThroughSource: clickThroughTracking,
                  title: price,
                  subtitle: address,
                  image,
                  badge: {
                    ...badge,
                    variant: mapApiBadgeVariantToBadgeVariant(badge.variant),
                  },
                  features,
                }),
              )}
              tracking={tracking}
              searchPageWebLink={
                searchPageWebLink ? mapApiStatePageWebLinkToWebLink(searchPageWebLink) : undefined
              }
            />
          );
        },
      )}
    </>
  );
};
